const checkPerformanceByCinemasArray = (cinemaIds, performance) => {
    return cinemaIds && cinemaIds.includes(performance.cinemaId)
}

export default checkPerformanceByCinemasArray 